module.exports = __webpack_public_path__ + "static/media/view--off.0816218c.svg";